"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var Button_1 = tslib_1.__importDefault(require("../../components/Button"));
var Wrapper = styled_components_1["default"].form(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject([""], [""])));
var FormGroup = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  margin-bottom: 1rem;\n"], ["\n  margin-bottom: 1rem;\n"])));
var Label = styled_components_1["default"].label(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  margin-bottom: 0.5rem;\n  display: block;\n  :after {\n    content: ", ";\n    color: red;\n    padding-left: 0.3rem;\n  }\n"], ["\n  margin-bottom: 0.5rem;\n  display: block;\n  :after {\n    content: ", ";\n    color: red;\n    padding-left: 0.3rem;\n  }\n"])), function (_a) {
    var required = _a.required;
    return (required ? '"*"' : '');
});
var Control = styled_components_1["default"].input(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  background: #f1f1f1;\n  width: 100%;\n  border: 0;\n  border-radius: 4px;\n  padding: 0.7em 1em;\n  font-size: 14px;\n  height: 40px;\n"], ["\n  background: #f1f1f1;\n  width: 100%;\n  border: 0;\n  border-radius: 4px;\n  padding: 0.7em 1em;\n  font-size: 14px;\n  height: 40px;\n"])));
var Input = (0, styled_components_1["default"])(Control)(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject([""], [""])));
var Select = Control.withComponent('select');
var Option = styled_components_1["default"].option(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject([""], [""])));
var Textarea = (0, styled_components_1["default"])(Control.withComponent('textarea'))(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["\n  min-height: 100px;\n  min-width: 100%;\n"], ["\n  min-height: 100px;\n  min-width: 100%;\n"])));
var ButtonContainer = styled_components_1["default"].div(templateObject_8 || (templateObject_8 = tslib_1.__makeTemplateObject(["\n  text-align: right;\n"], ["\n  text-align: right;\n"])));
var Form = /** @class */ (function (_super) {
    tslib_1.__extends(Form, _super);
    function Form() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            values: {
                name: '',
                subject: '',
                email: '',
                message: '',
                phone: ''
            }
        };
        _this.handleChange = function (ev) {
            var values = tslib_1.__assign({}, _this.state.values);
            values[ev.currentTarget.name] = ev.currentTarget.value;
            _this.setState({ values: values });
        };
        _this.handleSubmit = function (ev) {
            ev.preventDefault();
            var onSubmit = _this.props.onSubmit;
            onSubmit(_this.state.values);
        };
        return _this;
    }
    Form.prototype.render = function () {
        var _a = this.props.subjects, subjects = _a === void 0 ? [] : _a;
        var values = this.state.values;
        return (react_1["default"].createElement(Wrapper, { onSubmit: this.handleSubmit },
            react_1["default"].createElement(FormGroup, null,
                react_1["default"].createElement(Label, { required: true, htmlFor: "name" }, "Va\u0161e meno"),
                react_1["default"].createElement(Input, { id: "name", type: "text", name: "name", onChange: this.handleChange, value: values.name, required: true })),
            react_1["default"].createElement(FormGroup, null,
                react_1["default"].createElement(Label, { required: true, htmlFor: "email" }, "V\u00E1\u0161 email"),
                react_1["default"].createElement(Input, { id: "email", type: "email", name: "email", onChange: this.handleChange, value: values.email, required: true })),
            react_1["default"].createElement(FormGroup, null,
                react_1["default"].createElement(Label, { htmlFor: "phone" }, "Va\u0161e telef\u00F3nne \u010D\u00EDslo"),
                react_1["default"].createElement(Input, { id: "phone", type: "text", name: "phone", onChange: this.handleChange, value: values.phone })),
            react_1["default"].createElement(FormGroup, null,
                react_1["default"].createElement(Label, { required: true, htmlFor: "subject" }, "Predmet"),
                react_1["default"].createElement(Select, { id: "subject", name: "subject", onChange: this.handleChange, value: values.subject, required: true },
                    react_1["default"].createElement(Option, { value: "" }, "Vyberte"),
                    subjects.map(function (subject) { return (react_1["default"].createElement(Option, { value: subject }, subject)); }))),
            react_1["default"].createElement(FormGroup, null,
                react_1["default"].createElement(Label, { required: true, htmlFor: "message" }, "Spr\u00E1va"),
                react_1["default"].createElement(Textarea, { id: "message", onChange: this.handleChange, name: "message", value: values.message, required: true })),
            react_1["default"].createElement(ButtonContainer, null,
                react_1["default"].createElement(Button_1["default"], null, "Odosla\u0165"))));
    };
    return Form;
}(react_1.Component));
exports["default"] = Form;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
